import { doc, serverTimestamp, updateDoc } from 'firebase/firestore'
import { db } from '@/config/firebase'
import type { StageStatus } from '@/types/project'

/**
 * Set a stage's completion status (admin only, per firestore.rules). The
 * onProjectStageWrite trigger then recomputes greenCount and completion.
 */
export async function setStageStatus(
  projectId: string,
  stage: number,
  status: StageStatus,
  updatedBy: string,
): Promise<void> {
  await updateDoc(doc(db, 'projects', projectId), {
    [`stages.${stage}.status`]: status,
    [`stages.${stage}.updatedAt`]: serverTimestamp(),
    [`stages.${stage}.updatedBy`]: updatedBy,
  })
}
